// extracted by mini-css-extract-plugin
export const socialCont = "socialStyles-module--socialCont--2IwLw";
export const socialIcon = "socialStyles-module--socialIcon--1QWlv";